import i18n from "i18next";
import HttpApi from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';
import { context } from "./utils";


i18n
    .use(HttpApi) // passes i18n down to react-i18next
    .use(initReactI18next)
    .init({
        backend: {

            loadPath: `/api/v1/i18n/`,
            parse: function (data) {
                const parsed = JSON.parse(data);
                return parsed.catalog;
                //return { "foo": "bar" };//parsed.catalog;
            },
            customHeaders: {
                authorization: 'foo',
                'Accept-Language': context.current_language,
            },
        },
        resources: {},
        //resources: { "fr": { "translation": { "Choose items and order by drag & drop.": "fezzefzfezef" } } },
        // the translations
        // (tip move them in a JSON file and import them,
        // or even better, manage them via a UI: https://react.i18next.com/guides/multiple-translation-files#manage-your-translations-with-a-management-gui)
        lng: context.current_language, // if you're using a language detector, do not define the lng option
        load: 'languageOnly',
        fallbackLng: [context.current_language],
        ns: ["translation"],
        defaultNS: "translation",
        partialBundledLanguages: true,
        keySeparator: false, // we do not use keys in form messages.welcome
        interpolation: {
            escapeValue: false // react already safes from xss => https://www.i18next.com/translation-function/interpolation#unescape
        },
        react: { wait: true, useSuspense: true },
        //debug: true
    });

export default i18n;